import { $uberallLocations, mapboxAccessToken, defaultLocationsUrl } from './config';
import { render } from 'preact';
import LocationView from './modules/LocationView';
import 'mapbox-gl/dist/mapbox-gl.css';
import './uberall-locations.scss';

if ($uberallLocations) {
  const locationsUrl = $uberallLocations.getAttribute('data-locations-url') || defaultLocationsUrl;
  const consentNote = $uberallLocations.getAttribute('data-consent-note') || '';

  render(<LocationView locationsUrl={locationsUrl} accessToken={mapboxAccessToken} consentNote={consentNote} />, $uberallLocations);
}

function isTextClamped(element) {
  const clone = element.cloneNode(true);

  Object.assign(clone.style, {
    position: 'absolute',
    visibility: 'hidden',
    pointerEvents: 'none',
    height: 'auto',
    maxHeight: 'none',
    overflow: 'visible',
    display: 'block',
    WebkitLineClamp: 'unset',
    WebkitBoxOrient: 'unset',
    width: `${element.getBoundingClientRect().width}px`,
  });

  document.body.appendChild(clone);

  const fullHeight = clone.getBoundingClientRect().height;
  const clampedHeight = element.getBoundingClientRect().height;

  clone.remove();

  // add tolerance of +1 to mitigate subpixel calculations of browsers
  return fullHeight > clampedHeight + 1;
}

document.addEventListener("DOMContentLoaded", function() {
  const content = document.getElementById('location-desc');
  const text = document.getElementById('desc-text');
  const expandLink = document.getElementById('desc-expand-link');
  const photoexpandLink = document.getElementById('photo-expand-link');

  if (expandLink !== null) {
    expandLink.addEventListener('click', event => {
      if (expandLink.textContent === 'Mehr anzeigen') {
        expandLink.textContent = 'Weniger anzeigen';
        text.classList.remove('text-clip');
      } else {
        expandLink.textContent = 'Mehr anzeigen';
        text.classList.add('text-clip');
      }
    });

    if (isTextClamped(text)) {
      expandLink.style.display = 'block';
    } else {
      expandLink.style.display = 'none';
    }
  }

  if (photoexpandLink !== null) {
    photoexpandLink.addEventListener('click', event => {
      photoexpandLink.classList.toggle('clicked');
    });
  }
});
